angular.module('dashboard').controller('BillingDashboardCtrl',
                ['$scope', 'BillingService', 'DashboardService', 'TransitionManager', 'PatientPortalStorageRepository',
        function ($scope,   BillingService,   DashboardService,   TransitionManager,   PatientPortalStorageRepository) {

            'use strict';

            $scope.loading = true;

            $scope.makeAPaymentButtonEnabled = false;
            $scope.model = {
                Date: '',
                PersonBalanceAll: '',
                ConsentAnnual: '',
                owesUsMoney: false
            };

            var loginUserId = PatientPortalStorageRepository.getLoginUser().id;

            $scope.load = function (tile) {
                $scope.loading = true;
                $scope.tile = tile;

                loadPage();
            };

            function loadPage() {
                $scope.loading = true;
                $scope.removeHttpError();
                loginUserId = PatientPortalStorageRepository.getLoginUser().id;

                var requestDto = {
                    LoginUserPatientId: loginUserId,
                    RemoteSessionId: loginUserId + new Date().toLocaleDateString()
                };

                BillingService.getBillingAccount(requestDto)
                    .then(function (billingAccountDto) {
                        $scope.model.PersonBalanceAll = billingAccountDto.PersonBalanceAll;
                        $scope.model.owesUsMoney = $scope.model.PersonBalanceAll > 0;
                        $scope.model.Date = billingAccountDto.Date;
                        $scope.model.ConsentAnnual = billingAccountDto.ConsentAnnual;
                        $scope.model.DepositByFinancialCenterEnabled = billingAccountDto.DepositByFinancialCenterEnabled;
                        $scope.model.MerchantIdByFinancialCenterEnabled = billingAccountDto.MerchantIdByFinancialCenterEnabled;
                        $scope.model.DefaultMerchantId = billingAccountDto.DefaultMerchantId;
                        $scope.model.FinancialCenterBalances = billingAccountDto.FinancialCenterBalances;
                        $scope.model.ShowMultipleFinancialCenters = (!!$scope.model.FinancialCenterBalances && $scope.model.FinancialCenterBalances.length > 1);
                    })
                    .catch(function (response) {
                        $scope.addHttpError(response);
                    })
                    .finally(function () {
                        $scope.makeAPaymentButtonEnabled = BillingService.getViewMakeAPaymentFeatureFlag();
                        $scope.loading = false;
                    });
            }

            function makeSpecificOnlinePayment(balance) {
                if ($scope.model.ConsentAnnual && $scope.model.ConsentAnnual.CardType) {
                    if($scope.statementsOnly) {
                        TransitionManager.transition({appRoute: 'paymentOptionsStatementsOnly',
                            opts: {amount: balance.Balance, merchantId: balance.MerchantId, financialCenterUid: balance.FinancialCenterUid }});
                    } else {
                        TransitionManager.transition({appRoute: 'paymentOptions',
                            opts: {amount: balance.Balance, merchantId: balance.MerchantId, financialCenterUid: balance.FinancialCenterUid }});
                    }
                } else {
                    if($scope.statementsOnly) {
                        TransitionManager.transition({appRoute: 'paymentFromNewCardStatementsOnly',
                            opts: {amount: balance.Balance, merchantId: balance.MerchantId, financialCenterUid: balance.FinancialCenterUid }});
                    } else {
                        TransitionManager.transition({
                            appRoute: 'paymentFromNewCard',
                            opts: {amount: balance.Balance, merchantId: balance.MerchantId, financialCenterUid: balance.FinancialCenterUid }
                        });
                    }
                }
            }

            function makeGenericOnlinePayment() {
                if ($scope.model.ConsentAnnual && $scope.model.ConsentAnnual.CardType) {
                    if($scope.statementsOnly) {
                        TransitionManager.transition({appRoute: 'paymentOptionsStatementsOnly', opts: {amount: $scope.model.PersonBalanceAll, merchantId: $scope.model.DefaultMerchantId, financialCenterUid: $scope.model.FinancialCenterUid }});
                    } else {
                        TransitionManager.transition({appRoute: 'paymentOptions', opts: {amount: $scope.model.PersonBalanceAll, merchantId: $scope.model.DefaultMerchantId, financialCenterUid: $scope.model.FinancialCenterUid }});
                    }
                } else {
                    if($scope.statementsOnly) {
                        TransitionManager.transition({appRoute: 'paymentFromNewCardStatementsOnly', opts: {amount: $scope.model.PersonBalanceAll, merchantId: $scope.model.DefaultMerchantId, financialCenterUid: $scope.model.FinancialCenterUid }});
                    } else {
                        TransitionManager.transition({appRoute: 'paymentFromNewCard', opts: {amount: $scope.model.PersonBalanceAll, merchantId: $scope.model.DefaultMerchantId, financialCenterUid: $scope.model.FinancialCenterUid }});
                    }
                }
            }

            $scope.updateCollapseState = function updateCollapseState() {
                $scope.tile.IsCollapsed = !$scope.tile.IsCollapsed;
                DashboardService.setPatientDashboardTileState($scope.tile);
            };
            $scope.makeSpecificOnlinePayment = makeSpecificOnlinePayment;
            $scope.makeGenericOnlinePayment = makeGenericOnlinePayment;
        }
    ]
);